import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.pageTitle',
    defaultMessage: 'Inserimento numero di cellulare secondario',
    description: 'Title of the insert phone number user registration page',
  },
  pageSubtitle: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.pageSubtitle',
    defaultMessage:
      'Inserisci un secondo numero di cellulare che desideri associare al servizio',
    description: 'Subtitle of the insert phone number user registration page',
  },
  buttonSendCodeByPhone: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.buttonSendCodeByPhone',
    defaultMessage: 'OK',
    description:
      'Label of the insert phone number user registration button send code',
  },
  buttonSkip: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.buttonSkip',
    defaultMessage: 'Salta',
    description:
      'Label of the insert phone number user registration button send code',
  },
  labelInsertPhoneNumberInputText: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.labelInsertPhoneNumberInputText',
    defaultMessage: 'Numero di cellulare',
    description: 'Label of phone input text',
  },
  placeholderInsertPhoneNumberInputText: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.placeholderInsertPhoneNumberInputText',
    defaultMessage: 'Numero di cellulare',
    description: 'Placeholder of phone input text',
  },
  descriptionDisclaimerInsertPhoneNumber: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.descriptionDisclaimerInsertPhoneNumber',
    defaultMessage:
      'Il numero di cellulare secondario può essere inserito successivamente dalla sezione “Il mio profilo”. Nel caso in cui si voglia modificare il numero di cellulare, è necessario accedere al proprio MyAzimut ed effettuare la richiesta di variazione',
    description: 'Text of description disclaimer insert phone number',
  },
  errorInvalidPhoneNumberFormat: {
    id: 'features.insertSecondaryPhoneNumberUserRegistration.errorInvalidPhoneNumberFormat',
    defaultMessage: 'Numero di cellulare non corretto. Si prega di controllare',
    description: 'Error message shown when the phone number format is invalid',
  }
});
